import { Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

export const seeMoreButtonStyles = (theme: Theme) => ({
	button: {
		fontFamily: 'Integral CF',
		fontSize: '14px',
		fontWeight: '500',
		textTransform: 'uppercase',
		p: { xs: '6px 12px', md: '8px 16px', lg: '12px 24px' },
		backgroundColor: Colors['F7F7F7'],
		borderRadius: '100px',
		border: '1px solid transparent',

		'&:hover': {
			border: '1px solid black',
			backgroundColor: 'white',
		},
	},
});
